<template>
  <div>
    <ModalCover :show_close="false" :modal_style="'rounded-15 modal-md'">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body" class="no-catchup-modal-section">
        <div class="background-display-image">
          <img v-lazy="localImg('PromoBannerBg.png')" alt />

          <div
            class="content d-flex flex-column justify-content-center align-items-center"
          >
            <div class="title font-weight-bold brand_navy text-center pt-2">
              Get Gradely CatchUp!
            </div>
            <!-- DESCRIPTION -->
            <div class="description text-center color_ash">
              Subscribe for Gradely CatchUp! to unlock thousands of gamified
              quizzes, video lessons and study materials
            </div>
            <!-- DESCRIPTION -->

            <!-- SUBSCRIBE BUTTON -->
            <div>
              <router-link
                :to="{
                  name:
                    account_type === 'student'
                      ? 'StudentUpgradePlan'
                      : 'ParentUpgradePlan',
                  query: { type: 'catchup' },
                }"
                class="btn btn-md btn-accent brand_navy font-weight-bold mb-2"
                >Subscribe Now</router-link
              >
            </div>

            <!-- REMIND BUTTON -->
            <div>
              <button
                @click="$emit('closeTriggered')"
                class="btn btn-md transparent_bg brand_navy z-depth-0 font-weight-bold"
              >
                Remind Me Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "CatchupSubscriptionStatus",

  components: {
    ModalCover,
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      cancel_subscription_modal: false,
    };
  },

  mounted() {},

  methods: {
    toggleSubscriptionModal() {
      this.cancel_subscription_modal = !this.cancel_subscription_modal;
    },
  },
};
</script>

<style lang="scss">
.no-catchup-modal-section {
  .background-display-image {
    position: relative;
    height: 500px;
    img {
      @include img_cover;
    }

    .content {
      @include transform_center;
      width: 60%;

      .title {
        font-size: 21px;
        line-height: 29px;
        margin-bottom: 10px;
      }
      .description {
        font-size: 14px;
        line-height: 165%;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
